import { create } from "zustand";
import type { IViewConfig } from "lola-framework-ui-test";
import type { IErrorState } from "../shared/error/interfaces/error";
import { errorInitialState, themeFormattedInitialState } from "../constants";
import type { IAmountState } from "../interfaces/amount";
import type { IPaymentState } from "../interfaces/payment";
import type { ICardState } from "../interfaces/card";
import type { IQuoteResponse } from "../services/api";
import type { DestinationPayoutInput } from "../interfaces/payout-instrument";

interface GlobalState {
  theme: IViewConfig;
  setTheme: (theme: IViewConfig) => void;

  linkId: string | null;
  setLinkId: (linkId: string | null) => void;

  errorState: IErrorState;
  setErrorState: (errorState: IErrorState) => void;

  amountState: IAmountState;
  setAmountState: (amountState: IAmountState) => void;

  paymentState: IPaymentState;
  setPaymentState: (paymentState: IPaymentState) => void;

  cardState: ICardState;
  setCardState: (cardState: ICardState) => void;

  cardList: ICardState[];
  setCardList: (cardList: ICardState[]) => void;

  quoteState: IQuoteResponse | null;
  setQuoteState: (quoteState: IQuoteResponse | null) => void;

  /** Pre-validated or saved destination card for lazy rail prepare. */
  payoutInstrument: DestinationPayoutInput | null;
  setPayoutInstrument: (payout: DestinationPayoutInput | null) => void;
}

export const useStore = create<GlobalState>((set) => ({
  theme: themeFormattedInitialState,
  setTheme: (theme) => {
    set(() => ({ theme }));
  },

  linkId: null,
  setLinkId: (linkId) => {
    set(() => ({ linkId }));
  },

  errorState: errorInitialState,
  setErrorState: (errorState) => {
    set(() => ({ errorState }));
  },

  amountState: {
    amount: "",
  },
  setAmountState: (amountState) => {
    set(() => ({ amountState }));
  },

  paymentState: {
    payment: null,
  },
  setPaymentState: (paymentState) => {
    set(() => ({ paymentState }));
  },

  cardState: {
    cardId: null,
    name: null,
    brand: null,
    last4: null,
    accountNumber: null,
    expirationDate: null,
    fullName: null,
    cvv: null,
  },
  setCardState: (cardState) => {
    set(() => ({ cardState }));
  },

  cardList: [],
  setCardList: (cardList) => {
    set(() => ({ cardList }));
  },

  quoteState: null,
  setQuoteState: (quoteState) => {
    set(() => ({ quoteState }));
  },

  payoutInstrument: null,
  setPayoutInstrument: (payoutInstrument) => {
    set(() => ({ payoutInstrument }));
  },
}));
